import { clevertap } from "@/_old/lib/clevertap";

clevertap.initialize();
